<template>
  <div class="main-frame">
    <div class="center-container" v-if="playing && !isAuth">
      <button @click="signUp" class="signup-button">SIGN UP</button>
      <button @click="funPlay" class="funplay-button">FUN PLAY</button>
    </div>
    <div class="iframe-container" :style="{ opacity: playing && !isAuth ? 0.1 : 1 }">
      <div
        v-if="isLoading"
        class="loaderbox"
        style="font-size: 30px; color: rgb(66, 68, 69)"
      >
        <div class="loader">
          {{ t(`Loading`) + "..." }}
          <span></span>
        </div>
      </div>

      <div class="icon-container">
        <!-- Close icon -->
        <div @click="$router.push('/')" class="new-tab-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <path
              fill="white"
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>

      <iframe
        class="iframe"
        :src="gameUrl"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
    <div class="bottom-container">
      <div class="bottom-c1"  >
        <span
        @click="$router.push('/')"
          style="
            border-radius: 6px;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #535161;
            cursor: pointer;
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </span>
      </div>
      <div class="bottom-c2" ></div>
      <div class="bottom-c3" >
    <span style="color: white; font-weight: normal; font-size: 16px;">Playing for real</span>

    <!-- Toggle switch -->
    <div
      @click="togglePlaying"
      :style="{
        display: 'flex',
        alignItems: 'center',
        width: '50px',
        height: '25px',
        borderRadius: '25px',
        backgroundColor: playing ? '#4caf50' : '#888',
        padding: '2px',
        cursor: 'pointer',
        position: 'relative',
        transition: 'background-color 0.3s',
      }"
    >
      <div
        :style="{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: 'white',
          position: 'absolute',
          transform: playing ? 'translateX(25px)' : 'translateX(0)',
          transition: 'transform 0.3s',
        }"
      ></div>
    </div>

    <!-- Fullscreen icon -->
    <div @click="toggleFullScreen" class="fullscreen-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24 24"
      >
        <path
          fill="white"
          d="M6 19h4v2H4v-6h2v4zm12-4h2v6h-6v-2h4v-4zM6 5v4H4V3h6v2H6zm12-2v2h-4v2h6V3h-2z"
        />
      </svg>
    </div>
    <div @click="openGameInNewWindow" >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <path
              fill="white"
              d="M14 3v2h3.59l-9.7 9.7 1.41 1.41L19 6.41V10h2V3h-7zM5 5h6V3H3v18h18v-8h-2v6H5V5z"
            />
          </svg>
        </div>
  </div>
    </div>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import axios from "axios";
import { decodeData } from "@/utils/utils";

export default {
  name: "GameIframe",
  data() {
    return {
      gameUrl: "",
      isLoading: true, // Initially set loading state to true
      playing: false, // Toggle state
      isAuth:false
    };
  },

  created() {
    if (decodeData(this.$route.params.api_provider_name) === "NEXUSGGREU") {
      this.fetchNexusGameUrl();
    } else if (
      decodeData(this.$route.params.api_provider_name) === "DREAMGATES"
    ) {
      this.fetchDreamGatesGameUrl();
    } else if (
      decodeData(this.$route.params.api_provider_name) === "EVERGAME"
    ) {
      this.fetchEverGameUrl();
    } else if (
      decodeData(this.$route.params.api_provider_name) === "WORLDSLOT"
    ) {
      this.fetchWorldslotGameUrl();
    } else if (decodeData(this.$route.params.api_provider_name) === "DIASLOT") {
      this.fetchDiaslotGameUrl();
    } else if (
      decodeData(this.$route.params.api_provider_name) === "TIMELESS"
    ) {
      this.fetchTimelessGameUrl();
    } else {
      this.fetchNexusGameUrl();
    }
  },
  methods: {
    t(key) {
      return this.$t(key);
    },
    decodeData,
    openGameInNewWindow() {
      if (this.gameUrl) {
        window.open(this.gameUrl, "_blank");
      }
    },

    togglePlaying() {
      this.playing = !this.playing;
       if(this.isAuth){
        this.fetchTimelessGameUrl()
       }
    },
    toggleFullScreen() {
      const iframeContainer = document.querySelector(".iframe-container");
      if (!document.fullscreenElement) {
        iframeContainer.requestFullscreen().catch((err) => {
          toast(`Error attempting to enable fullscreen mode: ${err.message}`);
        });
      } else {
        document.exitFullscreen();
      }
    },
    funPlay(){
      this.playing=false
    },
    signUp(){
    toast("Contact admin to create an account or log in.")
    },
    
    async fetchNexusGameUrl() {
      const token = localStorage.getItem("userToken");
      const username = localStorage.getItem("username");
      try {
        const payload = {
          user_code: username || "demouser01",
          provider_code: decodeData(this.$route.params.provider_id),
          game_code: decodeData(this.$route.params.game_id),
          lang: "en",
        };
        const apiUrl = `${process.env.VUE_APP_API_KEY}/api/secondary-game/nexus/get-game-url?site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`;
        const response = await axios.post(apiUrl, payload);
        if (response.data.status === 200) {
          this.gameUrl = response.data.data.launch_url;
        } else {
          toast(response?.data?.message);
        }
      } catch (error) {
        toast(error?.response?.data?.message || error?.message);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchDreamGatesGameUrl() {
      const token = localStorage.getItem("userToken");
      const username = localStorage.getItem("username");
      const user_code = localStorage.getItem("user_code");
      try {
        const payload = {
          user_code: user_code || 400202552,
          provider_id: decodeData(this.$route.params.provider_id),
          game_symbol: decodeData(this.$route.params.game_id),
          lang: 1,
          win_ratio: 0,
        };
        const apiUrl = `${process.env.VUE_APP_API_KEY}/api/secondary-game/dreamgates/get-game-url?site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`;
        const response = await axios.post(apiUrl, payload);
        if (response.data.status === 200) {
          this.gameUrl = response.data.data.game_url;
        } else {
          toast(response?.data?.message);
        }
      } catch (error) {
        toast(error?.response?.data?.message || error?.message);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchEverGameUrl() {
      const token = localStorage.getItem("userToken");
      const username = localStorage.getItem("username");
      try {
        const payload = {
          userCode: username || "Thomas1",
          nickName: decodeData(this.$route.params.game_id),
          vendorCode: decodeData(this.$route.params.provider_id),
          language: "en",
        };
        const apiUrl = `${process.env.VUE_APP_API_KEY}/api/secondary-game/evergame/get-game-url?site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`;
        const response = await axios.post(apiUrl, payload);
        console.log(
          response,
          response.status,
          response.data.data?.launchUrl,
          "cehcking response123"
        );
        if (response.status === 200) {
          this.gameUrl = response.data?.data.launchUrl;
        } else {
          toast(response?.data?.message);
        }
      } catch (error) {
        console.log(error, "cechk error");
        toast(error?.response?.data?.message || error?.message);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchWorldslotGameUrl() {
      const token = localStorage.getItem("userToken");
      const username = localStorage.getItem("username");
      try {
        const payload = {
          user_code: username,
          game_type: "slot",
          provider_code: decodeData(this.$route.params.provider_id),
          game_code: decodeData(this.$route.params.game_id),
          lang: "en",
        };
        const apiUrl = `${process.env.VUE_APP_API_KEY}/api/secondary-game/worldslot/get-game-url?site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`;
        const response = await axios.post(apiUrl, payload);
        if (response.status === 200) {
          this.gameUrl = response.data?.data.launch_url;
        } else {
          toast(response?.data?.message);
        }
      } catch (error) {
        console.log(error);
        toast(error?.response?.data?.message || error?.message);
      } finally {
        this.isLoading = false;
      }
    },
async fetchTimelessGameUrl() {
  const token = localStorage.getItem("userToken");
  const username = localStorage.getItem("username");
  const usernameToken = localStorage.getItem("usernameToken");
  try {
    const mode = this.playing&&this.isAuth ? "real" : "fun"; // Set mode based on playing state
    const payload = {
      user_code: username,
      provider_code: decodeData(this.$route.params.provider_id),
      game_code: decodeData(this.$route.params.game_id),
      language: "en",
      mode: mode, // Use the dynamically set mode
    };
    const headers= {
              "Content-Type": "application/json",
              token: token, // Token from localStorage
              usernametoken: usernameToken, // Username token from localStorage
            }
    const apiUrl = `${process.env.VUE_APP_API_KEY}/api/secondary-game/timeless/get-game-url?site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`;
    const response = await axios.post(apiUrl, payload, { headers });
    if (response.status === 200) {
      this.gameUrl = response.data?.data.launch_url;
    } else {
      toast(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    toast(error?.response?.data?.message || error?.message);
  } finally {
    this.isLoading = false;
  }
},
    async fetchDiaslotGameUrl() {
      const token = localStorage.getItem("userToken");
      const username = localStorage.getItem("username");
      try {
        const payload = {
          user_code: username,
          game_type: "slot",
          provider_code: decodeData(this.$route.params.provider_id),
          game_code: decodeData(this.$route.params.game_id),
          lang: "en",
        };
        const apiUrl = `${process.env.VUE_APP_API_KEY}/api/secondary-game/diaslot/get-game-url?site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`;
        const response = await axios.post(apiUrl, payload);
        if (response.status === 200) {
          this.gameUrl = response.data?.data.launch_url;
        } else {
          toast(response?.data?.message);
        }
      } catch (error) {
        console.log(error);
        toast(error?.response?.data?.message || error?.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    const userToken = localStorage.getItem("userToken");
    const usernameToken = localStorage.getItem("usernameToken");
    if(userToken&&usernameToken){
    this.togglePlaying()}
    if (userToken && usernameToken) {
      this.isAuth = true;
    }
  }
};
</script>

<style scoped>
/* Custom Scrollbar Styles */

.main-frame {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 90%;
  justify-content: center;
  margin: auto;
  /* border: 2px solid green; */
  position: relative;
}

.bottom-container {
  width: 95%;
  margin: auto;
  color: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -10px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #38364b;
  padding-left: 10px;
  padding-right: 10px;

}
.back-button {
  margin-top: 7%;
  margin-bottom: 20px;
  margin-left: 20px;
  color: "white";
  background-color: white;
  padding: 10px;
  border-radius: 6px;
}

.iframe-page {
  width: 100%;
  height: 80vh; /* Adjust height as needed */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* background: url("../../assets/images/main/bg-dashboard.webp"); */
  /* background-color: blue; */
  position: fixed;
  z-index: 100;
}

.bottom-c1{
  width: 100%;
}
.bottom-c2{
width: 100%; 
}
.bottom-c3{
  width: 100%;
  display: flex; width: 100%; align-items: center; gap: 10px;
  justify-content: flex-end;
}
.iframe-container {
  width: 95%;
  margin: auto;
  height: 75vh;
  margin-top: 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  flex-grow: 1; /* Allow the iframe container to take up remaining space */
  overflow: hidden; /* Hide any overflow content */
}
.iframe {
  width: 100%;
  height: 100%;
  /* padding: 10px; */
  background: #000;
  z-index: 1;
}
.cross {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  position: absolute;
  padding: 10px;
  right: 40px;
}
.icon-container {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 40px;
  top: 10px;
}

@media screen and (max-width: 1024px) {
  .cross {
    display: none;
  }
  .bottom-container {
  width: 100%;
  margin:auto;
  color: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #38364b;
  padding-left: 2%;
  padding-right: 2%;

}

.bottom-c1{
  width: auto;
}
.bottom-c2{
width: 100%; 
display: none;
}
.bottom-c3{
  width: 100%;
  display: flex; width: 100%; align-items: center; gap: 10px;
  justify-content: flex-end;
}
}

.center-container {
  margin-bottom: 20px; /* Spacing for the buttons */
  position:absolute;
  display: flex;
  z-index: 10000;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.signup-button{
  background-color: #00bd71;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 16px;
  margin: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 900;
}
.funplay-button{
  background-color: #40404C;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 16px;
  margin: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 900;
}
.signup-button:hover,
.funplay-button:hover {
  opacity: 0.8; /* Hover effect */
}
@media screen and (max-width: 1024px) {
  .iframe-container {
    width: 100%;
    margin: auto;
    margin-top: 0px;
    border-radius: 0px;
    flex-grow: 1; /* Allow the iframe container to take up remaining space */
    overflow: hidden; /* Hide any overflow content */
    height: 90vh;
    margin-bottom: 0px;
  }
  .icon-container {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .bottom-container {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0px;
    bottom: -10px;
    width: 100%;
  }

  .iframe {
    width: 100%;
    height: 100%;
    padding: 0px;
    /* background: #000; */
  }

}

.loaderbox {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: #000000;
}

.fullscreen-icon,
.new-tab-icon,
.cross {
  cursor: pointer;
  padding: 20px;
}
</style>
